import React, { useState } from 'react';
import { HeadphonesIcon, PlusIcon, SearchIcon, ClockIcon, AlertCircleIcon, CheckCircleIcon, MessageSquareIcon, UserIcon, LinkIcon, ArrowRightIcon, XIcon, BookOpenIcon, ChevronRightIcon, AlertTriangleIcon, TimerIcon, PhoneIcon, MailIcon, MessageCircleIcon, SmartphoneIcon, UsersIcon, ExternalLinkIcon } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
export function SupportPage() {
  const {
    supportCases
  } = useAppContext();
  const [activeTab, setActiveTab] = useState('open');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedCase, setSelectedCase] = useState<string | null>(null);
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const showToast = (message: string) => {
    setToastMessage(message);
    setTimeout(() => setToastMessage(null), 3000);
  };
  const tabs = [{
    id: 'open',
    label: 'Open Cases',
    count: supportCases.filter(c => c.status === 'open').length
  }, {
    id: 'my',
    label: 'My Cases',
    count: supportCases.filter(c => c.requester === 'Alex Morgan' || c.requester === 'Current User').length
  }, {
    id: 'all',
    label: 'All Cases',
    count: supportCases.length
  }, {
    id: 'kb',
    label: 'Knowledge Base',
    count: 0
  }];
  const filteredCases = activeTab === 'kb' ? [] : activeTab === 'all' ? supportCases : activeTab === 'open' ? supportCases.filter(c => c.status === 'open' || c.status === 'in_progress') : supportCases.filter(c => c.requester === 'Alex Morgan');
  const selectedCaseData = supportCases.find(c => c.id === selectedCase);
  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'urgent':
        return 'bg-red-100 text-red-700';
      case 'high':
        return 'bg-amber-100 text-amber-700';
      case 'medium':
        return 'bg-blue-100 text-blue-700';
      case 'low':
        return 'bg-slate-100 text-slate-600';
      default:
        return 'bg-slate-100 text-slate-600';
    }
  };
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'open':
        return 'bg-blue-100 text-blue-700';
      case 'in_progress':
        return 'bg-amber-100 text-amber-700';
      case 'waiting':
        return 'bg-purple-100 text-purple-700';
      case 'resolved':
        return 'bg-emerald-100 text-emerald-700';
      case 'closed':
        return 'bg-slate-100 text-slate-600';
      default:
        return 'bg-slate-100 text-slate-600';
    }
  };
  const kbArticles = [{
    title: 'How to request a booking change',
    category: 'Bookings',
    views: 342
  }, {
    title: 'Understanding refund policies',
    category: 'Refunds',
    views: 256
  }, {
    title: 'Travel policy guidelines',
    category: 'Policy',
    views: 189
  }, {
    title: 'Expense report submission guide',
    category: 'Expenses',
    views: 145
  }, {
    title: 'Visa requirements FAQ',
    category: 'Travel',
    views: 128
  }, {
    title: 'How to cancel a trip',
    category: 'Cancellations',
    views: 112
  }];
  return <div className="space-y-6" data-id="element-2816">
      {/* Toast */}
      {toastMessage && <div className="fixed top-20 right-6 z-50 animate-in slide-in-from-top-2" data-id="element-2817">
          <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 rounded-lg p-4 shadow-lg flex items-center gap-3" data-id="element-2818">
            <CheckCircleIcon className="h-5 w-5 text-emerald-600 flex-shrink-0" data-id="element-2819" />
            <p className="font-medium text-sm" data-id="element-2820">{toastMessage}</p>
            <button onClick={() => setToastMessage(null)} className="ml-2 text-emerald-500 hover:text-emerald-700" data-id="element-2821">
              <XIcon className="h-4 w-4" data-id="element-2822" />
            </button>
          </div>
        </div>}

      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-2823">
        <div data-id="element-2824">
          <h2 className="text-2xl font-bold text-navy-900" data-id="element-2825">Support Center</h2>
          <p className="text-slate-500" data-id="element-2826">
            Get help through multiple channels or manage your support cases.
          </p>
        </div>
        <button onClick={() => setShowCreateModal(true)} className="flex items-center rounded-lg bg-navy-900 px-4 py-2 text-sm font-medium text-white hover:bg-navy-700 transition-colors" data-id="element-2827">
          <PlusIcon className="mr-2 h-4 w-4" data-id="element-2828" />
          New Support Case
        </button>
      </div>

      {/* Multi-Channel Contact Section */}
      <div className="rounded-2xl border border-navy-200 bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900 p-6 shadow-lg" data-id="element-2829">
        <div className="flex items-center gap-3 mb-5" data-id="element-2830">
          <div className="h-10 w-10 rounded-full bg-gold-500 flex items-center justify-center" data-id="element-2831">
            <HeadphonesIcon className="h-5 w-5 text-navy-900" data-id="element-2832" />
          </div>
          <div data-id="element-2833">
            <h3 className="text-lg font-bold text-white" data-id="element-2834">Contact Us</h3>
            <p className="text-sm text-slate-300" data-id="element-2835">
              Reach our team through your preferred channel
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-2836">
          {/* WhatsApp Business */}
          <div className="rounded-xl bg-white/10 backdrop-blur-sm border border-white/10 p-4 hover:bg-white/15 transition-colors" data-id="element-2837">
            <div className="flex items-center gap-3 mb-3" data-id="element-2838">
              <div className="h-10 w-10 rounded-lg bg-emerald-500 flex items-center justify-center flex-shrink-0" data-id="element-2839">
                <MessageCircleIcon className="h-5 w-5 text-white" data-id="element-2840" />
              </div>
              <div data-id="element-2841">
                <h4 className="font-semibold text-white text-sm" data-id="element-2842">
                  WhatsApp Business
                </h4>
                <p className="text-xs text-slate-300" data-id="element-2843">+234 801 234 5678</p>
              </div>
            </div>
            <p className="text-[10px] text-slate-400 mb-3" data-id="element-2844">
              Available Mon-Sat, 8AM-10PM WAT
            </p>
            <button onClick={() => showToast('Opening WhatsApp chat...')} className="w-full flex items-center justify-center gap-1.5 rounded-lg bg-emerald-500 px-3 py-2 text-xs font-semibold text-white hover:bg-emerald-600 transition-colors" data-id="element-2845">
              <MessageCircleIcon className="h-3.5 w-3.5" data-id="element-2846" /> Chat on WhatsApp
            </button>
          </div>

          {/* Phone Hotline */}
          <div className="rounded-xl bg-white/10 backdrop-blur-sm border border-white/10 p-4 hover:bg-white/15 transition-colors" data-id="element-2847">
            <div className="flex items-center gap-3 mb-3" data-id="element-2848">
              <div className="h-10 w-10 rounded-lg bg-blue-500 flex items-center justify-center flex-shrink-0" data-id="element-2849">
                <PhoneIcon className="h-5 w-5 text-white" data-id="element-2850" />
              </div>
              <div data-id="element-2851">
                <h4 className="font-semibold text-white text-sm" data-id="element-2852">
                  Phone Hotline
                </h4>
                <p className="text-xs text-slate-300" data-id="element-2853">+234 700 TRAVEL</p>
              </div>
            </div>
            <p className="text-[10px] text-slate-400 mb-3" data-id="element-2854">
              24/7 — Emergency & urgent requests
            </p>
            <button onClick={() => showToast('Initiating call to +234 700 TRAVEL...')} className="w-full flex items-center justify-center gap-1.5 rounded-lg bg-blue-500 px-3 py-2 text-xs font-semibold text-white hover:bg-blue-600 transition-colors" data-id="element-2855">
              <PhoneIcon className="h-3.5 w-3.5" data-id="element-2856" /> Call Now
            </button>
          </div>

          {/* Email Support */}
          <div className="rounded-xl bg-white/10 backdrop-blur-sm border border-white/10 p-4 hover:bg-white/15 transition-colors" data-id="element-2857">
            <div className="flex items-center gap-3 mb-3" data-id="element-2858">
              <div className="h-10 w-10 rounded-lg bg-slate-500 flex items-center justify-center flex-shrink-0" data-id="element-2859">
                <MailIcon className="h-5 w-5 text-white" data-id="element-2860" />
              </div>
              <div data-id="element-2861">
                <h4 className="font-semibold text-white text-sm" data-id="element-2862">
                  Email Support
                </h4>
                <p className="text-xs text-slate-300 truncate" data-id="element-2863">
                  support@superinternational.com
                </p>
              </div>
            </div>
            <p className="text-[10px] text-slate-400 mb-3" data-id="element-2864">
              Response within 2 business hours
            </p>
            <button onClick={() => showToast('Opening email client...')} className="w-full flex items-center justify-center gap-1.5 rounded-lg bg-slate-500 px-3 py-2 text-xs font-semibold text-white hover:bg-slate-600 transition-colors" data-id="element-2865">
              <MailIcon className="h-3.5 w-3.5" data-id="element-2866" /> Send Email
            </button>
          </div>

          {/* Live Chat */}
          <div className="rounded-xl bg-white/10 backdrop-blur-sm border border-white/10 p-4 hover:bg-white/15 transition-colors" data-id="element-2867">
            <div className="flex items-center gap-3 mb-3" data-id="element-2868">
              <div className="h-10 w-10 rounded-lg bg-gold-500 flex items-center justify-center flex-shrink-0" data-id="element-2869">
                <MessageSquareIcon className="h-5 w-5 text-navy-900" data-id="element-2870" />
              </div>
              <div data-id="element-2871">
                <h4 className="font-semibold text-white text-sm" data-id="element-2872">Live Chat</h4>
                <div className="flex items-center gap-1.5" data-id="element-2873">
                  <div className="h-1.5 w-1.5 rounded-full bg-emerald-400" data-id="element-2874" />
                  <p className="text-xs text-emerald-400" data-id="element-2875">Online</p>
                </div>
              </div>
            </div>
            <p className="text-[10px] text-slate-400 mb-3" data-id="element-2876">
              AI + human agents, instant response
            </p>
            <button onClick={() => showToast('Live chat opened — check the chat widget in the bottom right')} className="w-full flex items-center justify-center gap-1.5 rounded-lg bg-gold-500 px-3 py-2 text-xs font-semibold text-navy-900 hover:bg-gold-400 transition-colors" data-id="element-2877">
              <MessageSquareIcon className="h-3.5 w-3.5" data-id="element-2878" /> Start Chat
            </button>
          </div>

          {/* WhatsApp Group */}
          <div className="rounded-xl bg-white/10 backdrop-blur-sm border border-white/10 p-4 hover:bg-white/15 transition-colors" data-id="element-2879">
            <div className="flex items-center gap-3 mb-3" data-id="element-2880">
              <div className="h-10 w-10 rounded-lg bg-emerald-600 flex items-center justify-center flex-shrink-0" data-id="element-2881">
                <UsersIcon className="h-5 w-5 text-white" data-id="element-2882" />
              </div>
              <div data-id="element-2883">
                <h4 className="font-semibold text-white text-sm" data-id="element-2884">
                  WhatsApp Group
                </h4>
                <p className="text-xs text-slate-300" data-id="element-2885">Urgent Travel Alerts</p>
              </div>
            </div>
            <p className="text-[10px] text-slate-400 mb-3" data-id="element-2886">
              Real-time flight changes & disruptions
            </p>
            <button onClick={() => showToast('WhatsApp group invite link copied!')} className="w-full flex items-center justify-center gap-1.5 rounded-lg border border-emerald-400 px-3 py-2 text-xs font-semibold text-emerald-400 hover:bg-emerald-500/20 transition-colors" data-id="element-2887">
              <ExternalLinkIcon className="h-3.5 w-3.5" data-id="element-2888" /> Join Group
            </button>
          </div>

          {/* SMS Support */}
          <div className="rounded-xl bg-white/10 backdrop-blur-sm border border-white/10 p-4 hover:bg-white/15 transition-colors" data-id="element-2889">
            <div className="flex items-center gap-3 mb-3" data-id="element-2890">
              <div className="h-10 w-10 rounded-lg bg-purple-500 flex items-center justify-center flex-shrink-0" data-id="element-2891">
                <SmartphoneIcon className="h-5 w-5 text-white" data-id="element-2892" />
              </div>
              <div data-id="element-2893">
                <h4 className="font-semibold text-white text-sm" data-id="element-2894">
                  SMS Support
                </h4>
                <p className="text-xs text-slate-300" data-id="element-2895">Text HELP to 55555</p>
              </div>
            </div>
            <p className="text-[10px] text-slate-400 mb-3" data-id="element-2896">
              Quick status updates & confirmations
            </p>
            <button onClick={() => showToast('SMS shortcode copied: Text HELP to 55555')} className="w-full flex items-center justify-center gap-1.5 rounded-lg border border-purple-400 px-3 py-2 text-xs font-semibold text-purple-300 hover:bg-purple-500/20 transition-colors" data-id="element-2897">
              <SmartphoneIcon className="h-3.5 w-3.5" data-id="element-2898" /> Send SMS
            </button>
          </div>
        </div>
      </div>

      {/* SLA Summary */}
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-4" data-id="element-2899">
        <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm" data-id="element-2900">
          <div className="flex items-center gap-2 mb-2" data-id="element-2901">
            <div className="h-8 w-8 rounded-full bg-blue-50 flex items-center justify-center" data-id="element-2902">
              <HeadphonesIcon className="h-4 w-4 text-blue-600" data-id="element-2903" />
            </div>
            <span className="text-xs font-semibold text-slate-500 uppercase" data-id="element-2904">
              Open Cases
            </span>
          </div>
          <p className="text-2xl font-bold text-navy-900" data-id="element-2905">
            {supportCases.filter(c => c.status === 'open').length}
          </p>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm" data-id="element-2906">
          <div className="flex items-center gap-2 mb-2" data-id="element-2907">
            <div className="h-8 w-8 rounded-full bg-amber-50 flex items-center justify-center" data-id="element-2908">
              <ClockIcon className="h-4 w-4 text-amber-600" data-id="element-2909" />
            </div>
            <span className="text-xs font-semibold text-slate-500 uppercase" data-id="element-2910">
              In Progress
            </span>
          </div>
          <p className="text-2xl font-bold text-navy-900" data-id="element-2911">
            {supportCases.filter(c => c.status === 'in_progress').length}
          </p>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm" data-id="element-2912">
          <div className="flex items-center gap-2 mb-2" data-id="element-2913">
            <div className="h-8 w-8 rounded-full bg-emerald-50 flex items-center justify-center" data-id="element-2914">
              <CheckCircleIcon className="h-4 w-4 text-emerald-600" data-id="element-2915" />
            </div>
            <span className="text-xs font-semibold text-slate-500 uppercase" data-id="element-2916">
              Resolved
            </span>
          </div>
          <p className="text-2xl font-bold text-navy-900" data-id="element-2917">
            {supportCases.filter(c => c.status === 'resolved').length}
          </p>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm" data-id="element-2918">
          <div className="flex items-center gap-2 mb-2" data-id="element-2919">
            <div className="h-8 w-8 rounded-full bg-gold-50 flex items-center justify-center" data-id="element-2920">
              <TimerIcon className="h-4 w-4 text-gold-600" data-id="element-2921" />
            </div>
            <span className="text-xs font-semibold text-slate-500 uppercase" data-id="element-2922">
              Avg Response
            </span>
          </div>
          <p className="text-2xl font-bold text-navy-900" data-id="element-2923">1.5h</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex space-x-1 bg-slate-100 rounded-lg p-1" data-id="element-2924">
        {tabs.map(tab => <button key={tab.id} onClick={() => {
        setActiveTab(tab.id);
        setSelectedCase(null);
      }} className={`flex-1 rounded-md px-4 py-2 text-sm font-medium transition-colors ${activeTab === tab.id ? 'bg-white text-navy-900 shadow-sm' : 'text-slate-600 hover:text-slate-900'}`} data-id="element-2925">
            {tab.label}
            {tab.count > 0 && <span className={`ml-2 text-xs px-1.5 py-0.5 rounded-full ${activeTab === tab.id ? 'bg-navy-100 text-navy-700' : 'bg-slate-200 text-slate-600'}`} data-id="element-2926">
                {tab.count}
              </span>}
          </button>)}
      </div>

      {activeTab === 'kb' ? <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2927">
          {kbArticles.map((article, idx) => <div key={idx} className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm hover:shadow-md transition-shadow cursor-pointer" data-id="element-2928">
              <div className="flex items-start justify-between" data-id="element-2929">
                <div className="flex items-start gap-3" data-id="element-2930">
                  <div className="h-10 w-10 rounded-lg bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-2931">
                    <BookOpenIcon className="h-5 w-5 text-navy-600" data-id="element-2932" />
                  </div>
                  <div data-id="element-2933">
                    <h4 className="font-semibold text-slate-900 text-sm" data-id="element-2934">
                      {article.title}
                    </h4>
                    <span className="text-xs text-slate-500" data-id="element-2935">
                      {article.category} • {article.views} views
                    </span>
                  </div>
                </div>
                <ChevronRightIcon className="h-5 w-5 text-slate-400" data-id="element-2936" />
              </div>
            </div>)}
        </div> : <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2937">
          <div className={`space-y-3 ${selectedCase ? 'lg:col-span-1' : 'lg:col-span-3'}`} data-id="element-2938">
            {filteredCases.length === 0 ? <div className="text-center py-12 bg-white rounded-xl border border-slate-200" data-id="element-2939">
                <HeadphonesIcon className="h-12 w-12 mx-auto text-slate-300 mb-3" data-id="element-2940" />
                <p className="text-slate-500" data-id="element-2941">No cases found</p>
              </div> : filteredCases.map(c => <div key={c.id} onClick={() => setSelectedCase(c.id)} className={`rounded-xl border bg-white p-4 shadow-sm cursor-pointer transition-all ${selectedCase === c.id ? 'border-navy-400 ring-1 ring-navy-200' : 'border-slate-200 hover:border-slate-300 hover:shadow-md'}`} data-id="element-2942">
                  <div className="flex items-center justify-between mb-2" data-id="element-2943">
                    <span className="text-xs font-mono font-bold text-navy-700" data-id="element-2944">
                      {c.id}
                    </span>
                    <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${getPriorityColor(c.priority)}`} data-id="element-2945">
                      {c.priority.toUpperCase()}
                    </span>
                  </div>
                  <h4 className="font-semibold text-sm text-slate-900 mb-1 line-clamp-1" data-id="element-2946">
                    {c.subject}
                  </h4>
                  <p className="text-xs text-slate-500 mb-3 line-clamp-2" data-id="element-2947">
                    {c.description}
                  </p>
                  <div className="flex items-center justify-between" data-id="element-2948">
                    <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${getStatusColor(c.status)}`} data-id="element-2949">
                      {c.status.replace('_', ' ').toUpperCase()}
                    </span>
                    <div className="flex items-center gap-2 text-xs text-slate-400" data-id="element-2950">
                      <ClockIcon className="h-3 w-3" data-id="element-2951" />
                      {c.createdAt}
                    </div>
                  </div>
                  {c.slaResponseTime !== 'Met' && <div className="mt-2 flex items-center gap-1 text-[10px] text-amber-600" data-id="element-2952">
                      <AlertTriangleIcon className="h-3 w-3" data-id="element-2953" />
                      SLA: {c.slaResponseTime}
                    </div>}
                </div>)}
          </div>

          {selectedCase && selectedCaseData && <div className="lg:col-span-2 space-y-4" data-id="element-2954">
              <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-2955">
                <div className="flex items-center justify-between mb-4" data-id="element-2956">
                  <div data-id="element-2957">
                    <div className="flex items-center gap-2 mb-1" data-id="element-2958">
                      <span className="text-xs font-mono font-bold text-navy-700" data-id="element-2959">
                        {selectedCaseData.id}
                      </span>
                      <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${getStatusColor(selectedCaseData.status)}`} data-id="element-2960">
                        {selectedCaseData.status.replace('_', ' ').toUpperCase()}
                      </span>
                      <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${getPriorityColor(selectedCaseData.priority)}`} data-id="element-2961">
                        {selectedCaseData.priority.toUpperCase()}
                      </span>
                    </div>
                    <h3 className="text-lg font-bold text-slate-900" data-id="element-2962">
                      {selectedCaseData.subject}
                    </h3>
                  </div>
                  <button onClick={() => setSelectedCase(null)} className="p-1 hover:bg-slate-100 rounded-full" data-id="element-2963">
                    <XIcon className="h-5 w-5 text-slate-400" data-id="element-2964" />
                  </button>
                </div>

                <p className="text-sm text-slate-600 mb-4" data-id="element-2965">
                  {selectedCaseData.description}
                </p>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 bg-slate-50 rounded-lg mb-4" data-id="element-2966">
                  <div data-id="element-2967">
                    <span className="text-[10px] text-slate-400 uppercase font-semibold block" data-id="element-2968">
                      Requester
                    </span>
                    <span className="text-sm font-medium text-slate-900" data-id="element-2969">
                      {selectedCaseData.requester}
                    </span>
                  </div>
                  <div data-id="element-2970">
                    <span className="text-[10px] text-slate-400 uppercase font-semibold block" data-id="element-2971">
                      Assigned To
                    </span>
                    <span className="text-sm font-medium text-slate-900" data-id="element-2972">
                      {selectedCaseData.assignedTo || 'Unassigned'}
                    </span>
                  </div>
                  <div data-id="element-2973">
                    <span className="text-[10px] text-slate-400 uppercase font-semibold block" data-id="element-2974">
                      Category
                    </span>
                    <span className="text-sm font-medium text-slate-900" data-id="element-2975">
                      {selectedCaseData.category}
                    </span>
                  </div>
                  <div data-id="element-2976">
                    <span className="text-[10px] text-slate-400 uppercase font-semibold block" data-id="element-2977">
                      Linked Booking
                    </span>
                    <span className="text-sm font-medium text-navy-700" data-id="element-2978">
                      {selectedCaseData.linkedBooking || 'None'}
                    </span>
                  </div>
                </div>

                <div className="flex gap-4 mb-4" data-id="element-2979">
                  <div className={`flex-1 rounded-lg p-3 ${selectedCaseData.slaResponseTime === 'Met' ? 'bg-emerald-50 border border-emerald-200' : 'bg-amber-50 border border-amber-200'}`} data-id="element-2980">
                    <span className="text-[10px] font-semibold uppercase text-slate-500 block" data-id="element-2981">
                      Response SLA
                    </span>
                    <span className={`text-sm font-bold ${selectedCaseData.slaResponseTime === 'Met' ? 'text-emerald-700' : 'text-amber-700'}`} data-id="element-2982">
                      {selectedCaseData.slaResponseTime}
                    </span>
                  </div>
                  <div className={`flex-1 rounded-lg p-3 ${selectedCaseData.slaResolutionTime === 'Met' ? 'bg-emerald-50 border border-emerald-200' : 'bg-amber-50 border border-amber-200'}`} data-id="element-2983">
                    <span className="text-[10px] font-semibold uppercase text-slate-500 block" data-id="element-2984">
                      Resolution SLA
                    </span>
                    <span className={`text-sm font-bold ${selectedCaseData.slaResolutionTime === 'Met' ? 'text-emerald-700' : 'text-amber-700'}`} data-id="element-2985">
                      {selectedCaseData.slaResolutionTime}
                    </span>
                  </div>
                </div>

                <div className="flex gap-2 mb-6" data-id="element-2986">
                  <button onClick={() => showToast('Opening linked booking details...')} className="flex items-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2 text-xs font-medium text-slate-700 hover:bg-slate-50 transition-colors" data-id="element-2987">
                    <LinkIcon className="h-3.5 w-3.5" data-id="element-2988" /> View Booking
                  </button>
                  <button onClick={() => showToast('Note added to case')} className="flex items-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2 text-xs font-medium text-slate-700 hover:bg-slate-50 transition-colors" data-id="element-2989">
                    <MessageSquareIcon className="h-3.5 w-3.5" data-id="element-2990" /> Add Note
                  </button>
                  <button onClick={() => showToast('Case escalated to supervisor')} className="flex items-center gap-1.5 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-xs font-medium text-amber-700 hover:bg-amber-100 transition-colors" data-id="element-2991">
                    <AlertCircleIcon className="h-3.5 w-3.5" data-id="element-2992" /> Escalate
                  </button>
                </div>

                <h4 className="text-sm font-bold text-slate-900 mb-3" data-id="element-2993">
                  Case Timeline
                </h4>
                <div className="space-y-0" data-id="element-2994">
                  {selectedCaseData.timeline.map((entry, idx) => <div key={idx} className="flex gap-3" data-id="element-2995">
                      <div className="flex flex-col items-center" data-id="element-2996">
                        <div className="h-6 w-6 rounded-full bg-navy-100 flex items-center justify-center flex-shrink-0" data-id="element-2997">
                          <div className="h-2 w-2 rounded-full bg-navy-600" data-id="element-2998" />
                        </div>
                        {idx < selectedCaseData.timeline.length - 1 && <div className="w-0.5 flex-1 bg-slate-200 my-1" data-id="element-2999" />}
                      </div>
                      <div className="pb-4" data-id="element-3000">
                        <p className="text-sm font-medium text-slate-900" data-id="element-3001">
                          {entry.action}
                        </p>
                        <div className="flex items-center gap-2 text-xs text-slate-400" data-id="element-3002">
                          <span data-id="element-3003">{entry.user}</span>
                          <span data-id="element-3004">•</span>
                          <span data-id="element-3005">{entry.time}</span>
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>}
        </div>}

      {/* Create Case Modal */}
      {showCreateModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm" data-id="element-3006">
          <div className="w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl max-h-[90vh] overflow-y-auto" data-id="element-3007">
            <div className="flex items-center justify-between mb-6" data-id="element-3008">
              <h3 className="text-lg font-bold text-slate-900" data-id="element-3009">
                New Support Case
              </h3>
              <button onClick={() => setShowCreateModal(false)} className="rounded-full p-1 hover:bg-slate-100" data-id="element-3010">
                <XIcon className="h-5 w-5 text-slate-500" data-id="element-3011" />
              </button>
            </div>
            <div className="space-y-4" data-id="element-3012">
              <div data-id="element-3013">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-3014">
                  Subject
                </label>
                <input type="text" className="w-full rounded-lg border border-slate-300 p-2.5 text-sm focus:border-navy-600 focus:outline-none focus:ring-1 focus:ring-navy-600" placeholder="Brief description of your issue" data-id="element-3015" />
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-3016">
                <div data-id="element-3017">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-3018">
                    Category
                  </label>
                  <select className="w-full rounded-lg border border-slate-300 p-2.5 text-sm focus:border-navy-600 focus:outline-none" data-id="element-3019">
                    <option data-id="element-3020">Booking Issue</option>
                    <option data-id="element-3021">Refund Request</option>
                    <option data-id="element-3022">Policy Question</option>
                    <option data-id="element-3023">Technical</option>
                    <option data-id="element-3024">Other</option>
                  </select>
                </div>
                <div data-id="element-3025">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-3026">
                    Priority
                  </label>
                  <select className="w-full rounded-lg border border-slate-300 p-2.5 text-sm focus:border-navy-600 focus:outline-none" data-id="element-3027">
                    <option data-id="element-3028">Low</option>
                    <option data-id="element-3029">Medium</option>
                    <option data-id="element-3030">High</option>
                    <option data-id="element-3031">Urgent</option>
                  </select>
                </div>
              </div>
              <div data-id="element-3032">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-3033">
                  Preferred Contact Channel
                </label>
                <select className="w-full rounded-lg border border-slate-300 p-2.5 text-sm focus:border-navy-600 focus:outline-none" data-id="element-3034">
                  <option data-id="element-3035">WhatsApp</option>
                  <option data-id="element-3036">Phone</option>
                  <option data-id="element-3037">Email</option>
                  <option data-id="element-3038">In-App Chat</option>
                </select>
              </div>
              <div data-id="element-3039">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-3040">
                  Linked Booking (optional)
                </label>
                <input type="text" className="w-full rounded-lg border border-slate-300 p-2.5 text-sm focus:border-navy-600 focus:outline-none" placeholder="e.g. BK-7829" data-id="element-3041" />
              </div>
              <div data-id="element-3042">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-3043">
                  Description
                </label>
                <textarea rows={4} className="w-full rounded-lg border border-slate-300 p-2.5 text-sm focus:border-navy-600 focus:outline-none focus:ring-1 focus:ring-navy-600" placeholder="Describe your issue in detail..." data-id="element-3044" />
              </div>
              <div className="flex gap-3 pt-2" data-id="element-3045">
                <button onClick={() => setShowCreateModal(false)} className="flex-1 rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50" data-id="element-3046">
                  Cancel
                </button>
                <button onClick={() => {
              setShowCreateModal(false);
              showToast('Support case created successfully');
            }} className="flex-1 rounded-lg bg-navy-900 px-4 py-2.5 text-sm font-medium text-white hover:bg-navy-700" data-id="element-3047">
                  Create Case
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}